import React from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Navbar from '../Navbar/Navbar'
import Footer from '../Footer/Footer'

const Terms = () => {
  return (
    <div>
      <Navbar />
      <Box sx={{ textAlign: "center" }}>
        <Typography variant="h4" sx={{ fontFamily: "rubik", fontWeight: "bold", textAlign: "center", marginTop: "0.5rem" }}>
          Terms and Conditions
        </Typography>
        <Typography variant="body2" color="gray" sx={{ fontFamily: "rubik" }}>
          Last Updated On 08-04-2025 14:24:56
        </Typography>
      </Box>
      <Box sx={{ maxWidth: 800, mx: "auto", mt: 3, p: 2, textAlign: "justify" }}>
        <Typography sx={{ mb: 2 }}>
          Please read these Terms and Conditions ("Terms", "Terms and Conditions") carefully before using the sabka.com website and the associated mobile application (collectively referred to as the "Platform") operated by SUBH BHARAT STUDY TOOL PVT LTD ("Company", "we", "us", or "our").
        </Typography>
        <Typography sx={{ mb: 2 }}>
          By accessing or using the Platform, you agree to be bound by these Terms. If you do not agree to these Terms, do not use the Platform.
        </Typography>

        <Typography variant="h6" sx={{ mt: 3, mb: 1 }}>1. Acceptance of Terms</Typography>
        <Typography sx={{ mb: 2 }}>
          Your use of the Platform constitutes your agreement to comply with these Terms, which may be updated or modified at any time. Continued use of the Platform after such changes constitutes acceptance of the revised Terms.
        </Typography>

        <Typography variant="h6" sx={{ mt: 3, mb: 1 }}>2. Eligibility</Typography>
        <ul>
          <li>Be at least 18 years of age;</li>
          <li>Have the legal capacity to enter into a binding agreement;</li>
          <li>Use the Platform for lawful purposes only.</li>
        </ul>
        <Typography sx={{ mb: 2 }}>
          If you represent an organization or company (Recruiter), you must be authorized to accept these Terms on their behalf.
        </Typography>

        <Typography variant="h6" sx={{ mt: 3, mb: 1 }}>3. User Categories</Typography>
        <ul>
          <li>
            <b>Job Seekers:</b> Individuals using the Platform to search for employment or career advancement services.
          </li>
          <li>
            <b>Recruiters:</b> Companies, agencies, or individuals offering job opportunities.
          </li>
        </ul>
        <Typography sx={{ mb: 2 }}>
          Both categories are collectively referred to as “Users”.
        </Typography>

        <Typography variant="h6" sx={{ mt: 3, mb: 1 }}>4. User Responsibilities</Typography>
        <ul>
          <li>Provide accurate, current, and complete information;</li>
          <li>Use the Platform for lawful and genuine job-seeking or recruitment purposes only;</li>
          <li>Not engage in misleading, harmful, or illegal activities;</li>
          <li>Not attempt to gain unauthorized access to any portion of the Platform.</li>
        </ul>

        <Typography variant="h6" sx={{ mt: 3, mb: 1 }}>5. Account and Security</Typography>
        <ul>
          <li>Maintaining the confidentiality of your account credentials;</li>
          <li>All activities that occur under your account;</li>
          <li>Notifying us immediately of any unauthorized use of your account.</li>
        </ul>
        <Typography sx={{ mb: 2 }}>
          We are not liable for any loss or damage arising from your failure to comply with this responsibility.
        </Typography>

        <Typography variant="h6" sx={{ mt: 3, mb: 1 }}>6. Content and Usage</Typography>
        <ul>
          <li>All content you upload (e.g., resumes, job postings) is accurate and does not violate any laws or rights;</li>
          <li>You grant the Company a non-exclusive, worldwide, royalty-free license to use, store, and display your content to fulfill the services of the Platform;</li>
          <li>We reserve the right to remove any content that violates these Terms or is deemed inappropriate.</li>
        </ul>

        <Typography variant="h6" sx={{ mt: 3, mb: 1 }}>7. Platform Use Restrictions</Typography>
        <ul>
          <li>Upload viruses, malware, or harmful content;</li>
          <li>Use bots or automated systems to scrape or harvest data;</li>
          <li>Reproduce, distribute, or modify the Platform’s content without prior written consent.</li>
        </ul>

        <Typography variant="h6" sx={{ mt: 3, mb: 1 }}>8. Termination of Use</Typography>
        <Typography sx={{ mb: 2 }}>
          We reserve the right to suspend or terminate your account or access to the Platform if you breach these Terms, without notice and at our sole discretion.
        </Typography>

        <Typography variant="h6" sx={{ mt: 3, mb: 1 }}>9. Intellectual Property</Typography>
        <Typography sx={{ mb: 2 }}>
          All content, design, graphics, and software on the Platform are the property of the Company and are protected by applicable intellectual property laws. You may not use, reproduce, or distribute any content without our express written permission.
        </Typography>

        <Typography variant="h6" sx={{ mt: 3, mb: 1 }}>10. Limitation of Liability</Typography>
        <Typography sx={{ mb: 2 }}>
          The Platform and its content are provided "as is" without warranties of any kind. We do not guarantee the accuracy, completeness, or timeliness of information. The Company is not liable for any direct, indirect, or incidental damages arising from your use of the Platform.
        </Typography>

        <Typography variant="h6" sx={{ mt: 3, mb: 1 }}>11. Privacy</Typography>
        <Typography sx={{ mb: 2 }}>
          Your use of the Platform is also governed by our Privacy Policy, which outlines how your personal data is collected, used, and protected.
        </Typography>

        <Typography variant="h6" sx={{ mt: 3, mb: 1 }}>12. Third-Party Services</Typography>
        <Typography sx={{ mb: 2 }}>
          We may provide links to third-party websites or services. We are not responsible for the content or practices of these external sites.
        </Typography>

        <Typography variant="h6" sx={{ mt: 3, mb: 1 }}>13. Governing Law and Jurisdiction</Typography>
        <Typography sx={{ mb: 2 }}>
          These Terms are governed by the laws of India. Any disputes arising from these Terms or use of the Platform shall be subject to the exclusive jurisdiction of the courts in [Insert City, India].
        </Typography>

        <Typography variant="h6" sx={{ mt: 3, mb: 1 }}>14. Contact Information</Typography>
        <Typography>
          For any questions about these Terms, please contact:
        </Typography>
        <Box sx={{ mt: 1, mb: 2, pl: 2 }}>
          <Typography>SUBH BHARAT STUDY TOOL PVT LTD</Typography>
          <Typography>Email: <a href="mailto:sbobby065@gmail.com">sbobby065@gmail.com</a></Typography>
          <Typography>Phone: <a href="tel:+919603198840">9603198840</a></Typography>
          <Typography>Address: 4-8-40, Chinnadevara Street, Ichapuram, Srikaulam, AP 532127.</Typography>
        </Box>
      </Box>
      <Footer/>
    </div>
  )
}

export default Terms